import { breakpoints } from 'style'
import styled from 'styled-components'

export const DocumentContainer = styled.div`
  padding: 30px 0;
  .content-wrapper {
    margin-top: 50px;
    h1 {
    }
    h2 {
      margin-bottom: 30px;
    }
    p {
      margin-bottom: 12px;
    }
  }
  @media (max-width: ${breakpoints.sm}px) {
  }
  @media (max-width: 413px), (max-height: 845px) {
  }
`
